import axios from "axios";
import { getBackendBaseUrl } from "./qrDownload";

const BACKEND_URL = getBackendBaseUrl();
const API = `${BACKEND_URL}/api`;

const _rawBackendEnv = (process.env.REACT_APP_BACKEND_URL || "").trim();
if (
  typeof window !== "undefined" &&
  (_rawBackendEnv === "" || _rawBackendEnv === "undefined")
) {
  console.warn(
    "[Smart-QR] REACT_APP_BACKEND_URL missing or invalid; using fallback API base:",
    BACKEND_URL || "(empty — relative /api)",
  );
}

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smartqr_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
export { BACKEND_URL, API };
